<template>
  <nav class="dui-navbar site-header collapsed" @mouseover="addActive($event)" @mouseout="removeActive($event)">
    <div class="navbar-container">
      <div class="navbar-header">
        <a href="/" class="navbar-brand ga-data"><span class="navbar-brand-logo"></span></a>
      </div>
      <div id="siteHeaderNavbar">
        <ul class="navbar-category">
          <li data-load-lazyr="false" class="category-item">
            <router-link class="ga-data font-opensans" to="/product">产品展示</router-link>
            <div class="dui-dropdown-menu full-screen">
              <div class="dropdown-container">
                <div class="nav-columns default">
                  <div class="grid-container">
                    <div class="grid stretch left grid-wrapper">
                      <div class="column-item cell" v-for="(item, index) in CategoryList" :key="index">
                        <div class="product-img">
                          <a @click="toProduct(item.id)" class="ga-data"><img :src="imgPrefix + item.image" :title="item.name" :alt="item.name" /></a>
                        </div>
                        <div class="product-link">
                          <a @click="toProduct(item.id)" class="ga-data title font-opensans">{{
                            item.name
                            }}</a>
                          <ul>
                            <li class="nav-item" v-for="(items, index2) in item.productList" :key="index2">
                              <a class="banner-link ga-data" :to="{
                                  name: 'productDetil',
                                  params: { id: items.id },
                                  
                                }"  @click="goToDetail('/productDetil',items.id)">{{ items.name }}</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <!-- <li class="category-item relative">
            <a href="https://dealer.hicoostart.com/" target="_blank" class="ga-data">经销商订货平台</a>
          </li> -->
          <li class="category-item relative">
            <router-link class="ga-data font-opensans" to="/news"
              >品牌资讯</router-link
            >
          </li>
          <li class="category-item relative">
            <router-link class="ga-data font-opensans" to="/about">关于酷士达</router-link>
          </li>
          <li class="category-item relative">
            <router-link class="ga-data font-opensans" to="/contact">联系我们</router-link>
          </li>
        </ul>
        <ul class="navbar-right">
          <li class="nav-account">
            <a href="javascript:void(0);;" class="dui-btn dui-btn-sm dui-btn-buy btn-store ga-data">商城</a>
            <div class="dui-dropdown-menu single">
              <ul>
                <li class="nav-item">
                  <a href="https://mall.jd.hk/index-12237804.html" target="_blank">酷士达京东</a>
                </li>
                <li class="nav-item">
                  <a href="https://kushidabgyp.tmall.com/" target="_blank">酷士达天猫</a>
                </li>
                <!-- <li class="nav-item">
                  <a href="https://dealer.hicoostart.com/" target="_blank">经销商订货平台</a>
                </li> -->
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { getProductByCategory } from "@/service/category";
export default {
  data() {
    return {
      CategoryList: [],
      imgPrefix: window.imgPrefix
    };
  },
  mounted() {
    this.getProductByCategory();
  },
  methods: {
    addActive($event) {
      $event.currentTarget.className = "dui-navbar site-header ";
    },
    goToDetail (path, id) {
      this.$router.push({ path, query: { id } })
    },
    toProduct(id) {
      this.$router.push({
        path: "/product",
        query: {
          id
        }
      });
    },
    removeActive($event) {
      $event.currentTarget.className = "dui-navbar site-header collapsed";
    },
    getProductByCategory() {
      getProductByCategory({}, res => {
        if (res.success) {
          this.CategoryList = res.data.filter((e, i) => {
            return i <= 5;
          });
        }
      });
    }
  }
};
</script>

<style>
#site-header .navbar-header .navbar-brand-logo {
  background-image: url("../../static/images/logo-z.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 80%!important;
}
#site-header:hover .navbar-header .navbar-brand .navbar-brand-logo,
.dui-navbar.navbar-searching .navbar-header .navbar-brand-logo {
  background-image: url("../../static/images/logo-z.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 80% !important;
}
.dui-navbar .navbar-header .navbar-brand-logo {
  background-image: url("../../static/images/logo-z.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 80%!important;
}
.dui-navbar:hover .navbar-header .navbar-brand .navbar-brand-logo,
.dui-navbar.navbar-searching .navbar-header .navbar-brand-logo {
  background-image: url("../../static/images/logo-z.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 80%!important;
  
}
.dui-navbar .top_language {
  margin: 6px 0px;
}
#site-header:hover .top_language {
  padding: 25px 12px;
  margin: 0;
}
#site-header:hover .top_language a {
  color: #333;
}
</style>


// WEBPACK FOOTER //
// src/framework/layout-header.vue